import { useEffect } from "react";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import axios from "axios";
import BreadCrumb from "../../components/common/BreadCrumb.tsx";
import axiosInstance from "../../Services/axiosInstance.ts";

const SupersetDashboard = () => {
    useEffect(() => {
        const getToken = async () => {
            try {
                const res = await axiosInstance.get("/api/v1/superset/guest-token");
                return res.data.guest_token; // must return token string only
            } catch (error) {
                console.error("Error fetching superset token:", error);
                throw error;
            }
        };

        const embed = async () => {
            await embedDashboard({
                id: window.env.REACT_APP_SUPERSET_DASHBOARD_ID,
                supersetDomain: window.env.REACT_APP_SUPERSET_URL,
                mountPoint: document.getElementById("superset-container"),

                fetchGuestToken: async () => await getToken(),

                dashboardUiConfig: {
                    hideTitle: true,
                    hideChartControls: true,
                    hideTab: true,
                },
            });
        };

        embed()
    }, []);

    return (
        <>
            <BreadCrumb moduleName={"Dashboard"} pageName={"Dashboard"} />
            <div className="dashboard-wrapper m-0">
                <div
                    id="superset-container"
                    style={{
                        flex: 1,
                        width: "100%",
                        height: "100%",
                    }}
                />
            </div>
        </>
    );

};

export default SupersetDashboard;
